// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newHeaderRootCategory":"rI8pK","dropdownMenu":"YKK2D","rightArrow":"KBeSb","svg-icon":"ugg-V","hybridHamburger":"tdASI"};